import react, { useState } from 'react';
import i18next from 'i18next';

import ResetPasswordView from './ResetPasswordView';
import Network from '../../lib/Network';
import { getLanguage, getSearchParams } from '../../lib/environment';

export default function ResetPassword (props) {
  const [message, setMessage] = useState('');
  const [state, setState] = useState('initial');
  const onSubmit = newPassword => {
    setState('waiting');
    Network.postResetPassword(newPassword, getToken(), getUserId(), getLanguage())
      .then(result => {
        if (result.status === 'EXPIRED_HASH') {
          setValues('initial', 'error.EXPIRED_HASH');
        } else if (result.status === 'SAME_AS_RECENT') {
          setValues('initial', 'error.SAME_AS_RECENT');
        } else if (result.status === 'NOT_COMPLEX') {
          setValues('initial', 'error.NOT_COMPLEX');
        } else if (result.status === 'INACTIVE_ACCOUNT') {
          setValues('initial', 'error.INACTIVE_ACCOUNT');
        } else if (result.status === 'SUCCESS') {
          setValues('success', 'change.success');
        } else {
          setValues('initial', 'error.unknown');
        }
      })
      .catch(error => {
        console.log(error);
        setValues('initial', 'error.networkError');
      });
  }
  return <ResetPasswordView onSubmit={onSubmit} message={message} state={state} />;

  function setValues(newState, newMessage) {
    setState(newState);
    setMessage(i18next.t(newMessage));
  }

  function getToken() {
    return getSearchParams().hash;
  }

  function getUserId() {
    return getSearchParams().id
  }
}